import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export const PricingQA = () => {
  useEffect(() => {
    // Handle hash navigation on page load
    if (window.location.hash === '#fsbo-question') {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const fsboQuestion = document.getElementById('fsbo-question');
        if (fsboQuestion) {
          fsboQuestion.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Add highlight class (permanently - stays highlighted)
          fsboQuestion.classList.add('highlight-fsbo');
        }
      }, 100);
    }
    if (window.location.hash === '#leads-question') {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const leadsQuestion = document.getElementById('leads-question');
        if (leadsQuestion) {
          leadsQuestion.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Add highlight class (permanently - stays highlighted)
          leadsQuestion.classList.add('highlight-fsbo');
        }
      }, 100);
    }
  }, []);

  const handleScrollToTop = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    // Clear the hash from URL
    if (window.history?.replaceState) {
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search
      );
    }

    // Scroll to the hero section (main content area at top)
    const heroSection = document.getElementById('hero-22');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // Fallback: scroll to top of page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="faqs-3"
      className="gr--whitesmoke pt--100 pt-[160px] lg:max-xl:pt-[80px] md:max-lg:pt-[70px] faqs-section"
    >
      <div className="container">
        {/* SECTION TITLE */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)]">
          <div
            className="md:w-10/12 lg:max-xl:w-9/12 xl:w-9/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full"
            style={{ paddingLeft: '24px' }}
          >
            <div className="section-title mb--70 xl:!mb-[70px] lg:max-xl:!mb-[55px] md:max-lg:!mb-[45px] sm:max-md:!mb-[40px] xsm:max-sm:!mb-[40px]">
              {/* Title */}
              <h2 className="s-52 w--700 xl:!text-[3.25rem] lg:max-xl:!text-[3rem] md:max-lg:!text-[2.79411rem] sm:max-md:!text-[2.375rem] xsm:max-sm:!text-[2.0625rem] !font-bold !tracking-[-0.5px] leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35]">
                Questions & Answers
              </h2>
              {/* Text */}
              <p className="s-21 color--grey xl:!text-[1.3125rem] xl:!mt-[18px] !mb-0 lg:max-xl:!mt-[15px] lg:max-xl:!text-[1.18755rem] md:max-lg:!text-[1.32352rem] md:max-lg:!mt-3 sm:max-md:!text-[1.21875rem] sm:max-md:!mt-3 xsm:max-sm:!text-[1.1875rem] xsm:max-sm:!mt-3 xsm:max-sm:px-[3%] xsm:max-sm:py-0">
                REALTOR.ca showing-request leads, shared vs exclusive delivery,
                wallet pricing, and how assignment works
              </p>
            </div>
          </div>
        </div>
        {/* FAQs-3 QUESTIONS */}
        <div className="faqs-3-questions">
          <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)]">
            {/* QUESTIONS HOLDER - LEFT COLUMN */}
            <div className="xl:w-6/12 lg:max-xl:w-6/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
              <div className="questions-holder px-[10px] py-0 lg:max-xl:!p-0 md:max-lg:!p-0">
                {/* QUESTION — shared vs exclusive */}
                <div
                  id="shared-exclusive-question"
                  className="question mb--35 !mb-[35px] wow fadeInUp"
                >
                  <h5 className="s-22 w--700 xl:!text-[1.375rem] lg:max-xl:!text-[1.25rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] !font-bold xl:!mb-[20px] lg:max-xl:!mb-[15px] md:max-lg:!mb-[12px] sm:max-md:!mb-[15px] xsm:max-sm:!mb-[15px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    Do you offer shared and exclusive leads?
                  </h5>
                  <p className="color--grey my-[25px] lg:max-xl:!mt-[20px] lg:max-xl:!mb-[15px] md:max-lg:!text-[0.9075rem] md:max-lg:my-[14px]">
                    Yes. We offer <strong>both</strong>. <strong>Shared</strong>{' '}
                    leads are distributed to up to <strong>two (2)</strong>{' '}
                    agents. <strong>Exclusive</strong> leads are distributed to{' '}
                    <strong>one (1)</strong> agent only. Availability and
                    pricing depend on inventory and lead type.
                  </p>
                </div>

                {/* QUESTION */}
                <div
                  id="leads-question"
                  className="question mb--35 !mb-[35px] wow fadeInUp"
                >
                  <h5 className="s-22 w--700 xl:!text-[1.375rem] lg:max-xl:!text-[1.25rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] !font-bold xl:!mb-[20px] lg:max-xl:!mb-[15px] md:max-lg:!mb-[12px] sm:max-md:!mb-[15px] xsm:max-sm:!mb-[15px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    Where do your leads come from?
                  </h5>
                  <p className="text-gray-700 leading-relaxed">
                    Our leads come from actual showing requests on REALTOR.ca —
                    people who found a property, clicked &quot;Request a
                    Showing,&quot; and are waiting for an agent to contact them.
                    These aren&apos;t popup captures or recycled lists.
                    They&apos;re high-intent buyers and tenants who took action
                    on a listing.
                  </p>
                </div>

                {/* QUESTION */}
                <div
                  id="fsbo-question"
                  className="question mb--35 !mb-[35px] wow fadeInUp"
                >
                  <h5 className="s-22 w--700 xl:!text-[1.375rem] lg:max-xl:!text-[1.25rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] !font-bold xl:!mb-[20px] lg:max-xl:!mb-[15px] md:max-lg:!mb-[12px] sm:max-md:!mb-[15px] xsm:max-sm:!mb-[15px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    What is an FSBO listing?
                  </h5>
                  <p className="color--grey my-[25px] lg:max-xl:!mt-[20px] lg:max-xl:!mb-[15px] md:max-lg:!text-[0.9075rem] md:max-lg:my-[14px]">
                    As a bonus to BrokerMax subscribers, we connect you with
                    property owners who want their listing on Realtor.ca without
                    representation (FSBO; For Sale By Owner) - CREA calls this a
                    Mere Posting. We gather their listing information and
                    provide it to you to post as a mere listing - meaning you
                    don&apos;t receive a listing commission upfront.
                  </p>
                  <p className="color--grey">
                    While BrokerMax primarily delivers buyer and rental leads,
                    an added benefit is that a percentage of these FSBO sellers
                    will convert to full representation once they realize they
                    need your expertise to close the deal.
                  </p>
                  <p className="color--grey font-semibold">
                    ✅ &nbsp; If your brokerage does not allow for Mere
                    Postings, you can still receive Buyer and Rental leads.
                  </p>
                  <div className="mt-4">
                    <button
                      type="button"
                      onClick={handleScrollToTop}
                      className="inline-flex items-center text-[#1680fb] hover:text-[#1268d4] transition-colors font-medium text-[0.9375rem] font-Jakarta bg-transparent border-0 p-0 cursor-pointer"
                    >
                      <svg
                        className="w-4 h-4 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 10l7-7m0 0l7 7m-7-7v18"
                        />
                      </svg>
                      Scroll back to top
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* END QUESTIONS HOLDER - LEFT COLUMN */}

            {/* QUESTIONS WRAPPER - RIGHT COLUMN */}
            <div className="xl:w-6/12 lg:max-xl:w-6/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
              <div className="questions-holder px-[10px] py-0 lg:max-xl:!p-0 md:max-lg:!p-0">
                {/* QUESTION */}
                <div className="question mb--35 !mb-[35px] wow fadeInUp">
                  <h5 className="s-22 w--700 xl:!text-[1.375rem] lg:max-xl:!text-[1.25rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] !font-bold xl:!mb-[20px] lg:max-xl:!mb-[15px] md:max-lg:!mb-[12px] sm:max-md:!mb-[15px] xsm:max-sm:!mb-[15px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    What markets do you serve?
                  </h5>
                  <p className="color--grey my-[25px] lg:max-xl:!mt-[20px] lg:max-xl:!mb-[15px] md:max-lg:!text-[0.9075rem] md:max-lg:my-[14px]">
                    Currently we serve all major markets across Ontario and
                    Alberta. British Columbia is coming soon.
                  </p>
                </div>

                {/* QUESTION */}
                <div className="question mb--35 !mb-[35px] wow fadeInUp">
                  <h5 className="s-22 w--700 xl:!text-[1.375rem] lg:max-xl:!text-[1.25rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] !font-bold xl:!mb-[20px] lg:max-xl:!mb-[15px] md:max-lg:!mb-[12px] sm:max-md:!mb-[15px] xsm:max-sm:!mb-[15px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    How quickly will I start receiving leads?
                  </h5>
                  <p className="color--grey my-[25px] lg:max-xl:!mt-[20px] lg:max-xl:!mb-[15px] md:max-lg:!text-[0.9075rem] md:max-lg:my-[14px]">
                    Leads begin flowing within 24-48 hours of your subscription
                    activation. FSBO listings are assigned as they become
                    available, typically within the first week.
                  </p>
                </div>

                {/* QUESTION */}
                <div className="question mb--35 !mb-[35px] wow fadeInUp">
                  <h5 className="s-22 w--700 xl:!text-[1.375rem] lg:max-xl:!text-[1.25rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] !font-bold xl:!mb-[20px] lg:max-xl:!mb-[15px] md:max-lg:!mb-[12px] sm:max-md:!mb-[15px] xsm:max-sm:!mb-[15px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    What if the leads don&apos;t convert?
                  </h5>
                  <p className="color--grey my-[25px] lg:max-xl:!mt-[20px] lg:max-xl:!mb-[15px] md:max-lg:!text-[0.9075rem] md:max-lg:my-[14px]">
                    Conversion depends on your follow-up speed and sales
                    process. We deliver qualified, high-intent leads — but we
                    can&apos;t control how quickly you respond or how well you
                    close. Industry average close rates are 7-15%; our clients
                    typically see 10-15% with proper follow-up.
                  </p>
                </div>

                {/* QUESTION */}
                <div className="question mb--35 !mb-[35px] wow fadeInUp">
                  <h5 className="s-22 w--700 xl:!text-[1.375rem] lg:max-xl:!text-[1.25rem] md:max-lg:!text-[1.397058rem] sm:max-md:!text-[1.4375rem] xsm:max-sm:!text-[1.3125rem] !font-bold xl:!mb-[20px] lg:max-xl:!mb-[15px] md:max-lg:!mb-[12px] sm:max-md:!mb-[15px] xsm:max-sm:!mb-[15px] leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4]">
                    Can I cancel anytime?
                  </h5>
                  <p className="color--grey my-[25px] lg:max-xl:!mt-[20px] lg:max-xl:!mb-[15px] md:max-lg:!text-[0.9075rem] md:max-lg:my-[14px]">
                    Yes. Plans are month-to-month with no long-term contracts.
                    If you cancel, you&apos;ll continue receiving leads through
                    the end of your billing cycle.
                  </p>
                </div>
              </div>
            </div>
            {/* END QUESTIONS HOLDER - RIGHT COLUMN */}
          </div>
          {/* End row */}
        </div>
        {/* END FAQs-3 QUESTIONS */}
        {/* MORE QUESTIONS LINK */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)]">
          <div className="flex-[0_0_auto] w-full max-w-full px-[calc(0.5*_1.5rem)]">
            <div className="more-questions !text-center mt--40 mt-[40px] lg:max-xl:!mt-[30px] md:max-lg:!mt-[30px]">
              <div className="more-questions-txt bg--white-400 rounded-[100px] inline-block px-[46px] py-[22px] lg:max-xl:px-11 lg:max-xl:py-[18px] md:max-lg:px-[42px] md:max-lg:py-[18px] sm:max-md:px-[42px] sm:max-md:py-[18px] xsm:max-sm:px-9 xsm:max-sm:py-[18px]">
                <p className="p-lg leading-none !mb-0 lg:max-xl:!text-[1.125rem] md:max-lg:!text-[1.125rem] sm:max-md:!text-[1.125rem] xsm:max-sm:!text-[1.125rem]">
                  Questions? &nbsp;
                  <Link
                    to="/schedule-call"
                    className="color--theme font-medium !underline hover:text-[#353f4f] hover:!underline"
                  >
                    Schedule a call &#187;
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End container */}
    </section>
  );
};
